import * as React from 'react';

// tslint:disable-next-line:no-any
function isMouseEvent(event: MouseEvent | TouchEvent | React.MouseEvent<any> | React.TouchEvent<any>): event is MouseEvent {
  const e = <MouseEvent> event;
  return typeof e.clientX === 'number';
}

// tslint:disable-next-line:no-any
function isTouchEvent(event: MouseEvent | TouchEvent | React.MouseEvent<any> | React.TouchEvent<any>): event is TouchEvent {
  const e = <TouchEvent> event;
  return !!e.touches;
}

/**
 * Gets the client position from either the mouse event or the first touch from a touch event
 */
// tslint:disable-next-line:no-any
function getClientPosition(event: MouseEvent | TouchEvent | React.MouseEvent<any> | React.TouchEvent<any>): {x: number, y: number} {
  if (isMouseEvent(event)) {
    return {x: event.clientX, y: event.clientY};
  }
  if (isTouchEvent(event)) {
    return {x: event.touches[0].clientX, y: event.touches[0].clientY};
  }
  throw Error('Could not identify event as either MouseEvent or TouchEvent');
}

export { isMouseEvent, isTouchEvent, getClientPosition };
